import React from "react";
import { useNavigate } from "react-router-dom";
import { Result, Button } from "antd";
import { HomeOutlined } from "@ant-design/icons";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Result
      status="404"
      title="404"
      subTitle="Sorry, the page you visited does not exist."
      extra={
        <Button type="primary" icon={<HomeOutlined />} onClick={() => navigate("/hub")}>
          Back to My Hub
        </Button>
      }
    />
  );
};

export default NotFound;
